module.exports = __webpack_public_path__ + "static/customersloveus-2dea594d8659cdf068f6831783061862.png";